"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTierInput = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
exports.PriceTierInput = (props) => {
    const { startAdornment, endAdornment, inputRef, onChange } = props, inputProps = __rest(props, ["startAdornment", "endAdornment", "inputRef", "onChange"]);
    const useStyles = core_1.makeStyles({
        inputStyle: {
            border: 'none',
            outline: 'none',
        },
        disabledStyle: {
            opacity: '0.2'
        },
        inputContainer: {
            position: 'relative'
        }
    });
    const { inputContainer, inputStyle, disabledStyle, } = useStyles();
    const [width, setWidth] = react_1.useState(1);
    const handleChange = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
        if (event.target.value) {
            // in case input the value prop isnt set. then the width will always be set appropiately.
            setWidth(event.target.value.length + 1);
        }
    };
    react_1.useEffect(() => {
        if (inputProps.value) {
            setWidth(inputProps.value.length + 1);
        }
    }, [inputProps.value]);
    return (react_1.default.createElement("div", { className: `${inputContainer} ${inputProps.disabled ? disabledStyle : ''}` },
        startAdornment,
        react_1.default.createElement("input", Object.assign({}, inputProps, { onChange: handleChange, type: 'number', style: { width: `${width}ch` }, className: inputStyle })),
        endAdornment));
};
exports.default = exports.PriceTierInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpY2VUaWVySW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm9ybXMvUHJpY2VUaWVySW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBLCtDQUtpRDtBQUNqRCw0Q0FBNkQ7QUFVaEQsUUFBQSxjQUFjLEdBQTZCLENBQUMsS0FBWSxFQUFFLEVBQUU7SUFDckUsTUFBTSxFQUNGLGNBQWMsRUFDZCxZQUFZLEVBQ1osUUFBUSxFQUNSLFFBQVEsS0FFUixLQUFLLEVBREYsVUFBVSxVQUNiLEtBQUssRUFOSCwwREFNTCxDQUFRLENBQUM7SUFFVixNQUFNLFNBQVMsR0FBRyxpQkFBVSxDQUFDO1FBQ3pCLFVBQVUsRUFBRTtZQUNSLE1BQU0sRUFBRSxNQUFNO1lBQ2QsT0FBTyxFQUFFLE1BQU07U0FDbEI7UUFDRCxhQUFhLEVBQUU7WUFDWCxPQUFPLEVBQUUsS0FBSztTQUNqQjtRQUNELGNBQWMsRUFBRTtZQUNaLFFBQVEsRUFBRSxVQUFVO1NBQ3ZCO0tBQ0osQ0FBQyxDQUFDO0lBRUgsTUFBTSxFQUNGLGNBQWMsRUFDZCxVQUFVLEVBQ1YsYUFBYSxHQUNoQixHQUFHLFNBQVMsRUFBRSxDQUFDO0lBRWhCLE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEdBQUcsZ0JBQVEsQ0FBUyxDQUFDLENBQUMsQ0FBQztJQUM5QyxNQUFNLFlBQVksR0FBRyxDQUFDLEtBQTBDLEVBQUUsRUFBRTtRQUNoRSxJQUFHLFFBQVEsRUFBQztZQUNSLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ2hDO1FBRUQsSUFBRyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBQztZQUNsQix5RkFBeUY7WUFDekYsUUFBUSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztTQUMzQztJQUNMLENBQUMsQ0FBQTtJQUVELGlCQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBRyxVQUFVLENBQUMsS0FBSyxFQUFDO1lBQ2hCLFFBQVEsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztTQUN6QztJQUNMLENBQUMsRUFBRSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFBO0lBRXRCLE9BQU8sQ0FDSCx1Q0FBSyxTQUFTLEVBQUksR0FBRyxjQUFjLElBQUksVUFBVSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUU7UUFDNUUsY0FBYztRQUNmLHlEQUNRLFVBQVUsSUFDZCxRQUFRLEVBQUksWUFBWSxFQUN4QixJQUFJLEVBQUcsUUFBUSxFQUNmLEtBQUssRUFBSSxFQUFFLEtBQUssRUFBRSxHQUFHLEtBQUssSUFBSSxFQUFDLEVBQy9CLFNBQVMsRUFBSSxVQUFVLElBQ3pCO1FBQ0QsWUFBWSxDQUNYLENBQ1QsQ0FBQztBQUNOLENBQUMsQ0FBQTtBQUVELGtCQUFlLHNCQUFjLENBQUMifQ==